import { observable } from "mobx";
import Constants from "../constants/Constants";
import { realtimeEvent } from "../eventsource/RealtimeEvent";
import { IDashboardConfig, IShortCompanyInfo, IStockSymbol, REGISTER_SOCKET_TYPE, STOCK_BG_COLOR_CONIG } from "../model/Model";
import _ from 'lodash'
import { getRequest } from "../helpers/RequestHelper";
import { topStockStore } from "../../modules/TopStock/store";
import { cashFlowTrendingStore } from "../../modules/CashFlowTrending/store";
import HttpStatusCode from "../constants/HttpErrorCode";
import { stockRankingStore } from "../../modules/StockRanking/store";
import { orderMatchingByPriceStore } from "../../modules/OrderMatchingByPrice/store";
import { stockDetailStore } from './../../modules/StockDetail/store';
import { stockRecommendationStore } from "../../modules/StockRecommendations/store";
import { dashboardStore } from "../../modules/dashboard/DashboardStore";

export const defaultDashboardConfig = {
    version: '1.0.0.1',
    lastWorkSpaceId: '',
    showFullLeftMenu: false,
    workSpaces: [
        {
            id: '',
            title: "TVSI Dashboard",
            config: [
                {
                    id: 0,
                    module: 'MarketOverview',
                    state: {
                        symbols: ["VN-INDEX", "HNX-INDEX", "VN30", "UPCOM-INDEX"],
                    },
                },
                {
                    id: 1,
                    module: 'CashFlowTrending',
                    state: {
                        currentSymbol: 'AAA',
                        indexSymbol: 'VNINDEX'
                    },
                },
                {
                    id: 2,
                    module: 'HeatMapChart',
                    state: {
                    }
                },
                {
                    id: 5,
                    module: "StockChart",
                    state: {
                        indexSymbol: 'AAA'
                    }
                },
                {
                    id: 6,
                    module: 'OrderMatchingByPrice',
                    state: {
                        currentSymbol: 'AAA',
                        timeSymbol: '1'
                    },
                },
                // {
                //     id: 7,
                //     module: 'StockRanking',
                //     state: {
                //         indexSymbol: 'AAA',
                //         pageSize: 25
                //     },
                // },
                // {
                //     id: 10,
                //     module: "StockRecommendations",
                //     state: {
                //         currentSymbol: '27'
                //     }
                // },
                {
                    id: 8,
                    module: "News",
                    state: {
                        currentSymbol: '1'
                    }
                },
                {
                    id: 9,
                    module: "AnalysisReport",
                    state: {
                        currentSymbol: '27'
                    }
                },
                {
                    id: 4,
                    module: 'TopStock',
                    state: {
                        top: 10,
                        indexSymbol: '',
                        topType: 'Overview',
                        stockType: "TopUp",
                    },
                },
                {
                    id: 3,
                    module: 'VNIndexPePb',
                    state: {
                        currentSymbol: 'PE',
                        monthSymbol: '3',
                    },
                },
                {
                    id: 11,
                    module: "MarketStatistic",
                    state: {

                    }
                },


            ],
            stocks: []
        }
    ],
};
export const moduleConfigs = [
    {
        id: 0,
        module: 'MarketOverview',
        state: {
            symbols: ["VN-INDEX", "HNX-INDEX", "VN30", "UPCOM-INDEX"],
        },
        "title": "Diễn biến giao dịch trong ngày"
    },
    {
        id: 1,
        module: 'CashFlowTrending',
        state: {
            currentSymbol: 'AAA',
            indexSymbol: 'VNINDEX'
        },
        "title": "Xu hướng dòng tiền"
    },
    {
        id: 2,
        module: 'HeatMapChart',
        state: {
        },
        "title": "Bản đồ nhiệt thị trường"
    },
    {
        id: 3,
        module: 'VNIndexPePb',
        state: {
            currentSymbol: 'PE',
            monthSymbol: '3',
        },
        "title": "Định giá thị trường"
    },
    {
        id: 4,
        module: 'OrderMatchingByPrice',
        state: {
            currentSymbol: 'AAA',
            timeSymbol: '1'
        },
        "title": "Khớp lệnh theo bước giá"
    },
    {
        id: 5,
        module: 'TopStock',
        state: {
            top: 10,
            indexSymbol: '',
            topType: 'Overview',
            stockType: "TopUp",
        },
        "title": "TOP cổ phiếu"
    },
    // {
    //     id: 6,
    //     module: 'StockRanking',
    //     state: {
    //         indexSymbol: 'AAA',
    //         pageSize: 25
    //     },
    //     "title": "Xếp hạng cổ phiếu"
    // },



    {
        id: 8,
        module: "AnalysisReport",
        state: {
            currentSymbol: '27'
        },
        "title": "Báo cáo phân tích"
    },
    {
        id: 9,
        module: "News",
        state: {
            currentSymbol: '1'
        },
        "title": "Tin tức"
    },
    {
        id: 10,
        module: "StockChart",
        state: {
            indexSymbol: 'AAA'
        },
        "title": "Đồ thị phân tích kỹ thuật"
    },
    // {
    //     id: 11,
    //     module: "StockRecommendations",
    //     title: "Investment Robot Advisor - IRA"
    // },
    {
        id: 12,
        module: "MarketStatistic",
        title: "Thống kê thị trường"
    }
]
export const moduleConfig = [
    {
        "name": "MarketOverview",
        "title": "Diễn biến giao dịch trong ngày"
    },
    {
        "name": "CashFlowTrending",
        "title": "Xu hướng dòng tiền"
    },
    {
        "name": "HeatMapChart",
        "title": "Bản đồ nhiệt thị trường"
    },
    {
        "name": "StockChart",
        "title": "Đồ thị phân tích kỹ thuật"
    },
    {
        "name": "OrderMatchingByPrice",
        "title": "Khớp lệnh theo bước giá"
    },
    {
        "name": "StockRanking",
        "title": "Xếp hạng cổ phiếu"
    },
    // {
    //     "name": "TopUp",
    //     "title": "Top cổ phiếu tăng"
    // },
    // {
    //     "name": "TopDown",
    //     "title": "Top cổ phiếu giảm"
    // },
    {
        "name": "VNIndexPePb",
        "title": "Định giá thị trường"
    },
    {
        "name": "TopStock",
        "title": "TOP cổ phiếu"
    },
    {
        "name": "AnalysisReport",
        "title": "Báo cáo phân tích"
    },
    {
        "name": "News",
        "title": "Tin tức"
    },
    {
        "name": "StockRecommendations",
        "title": "Investment Robot Advisor - IRA"
    },
    {
        "name": "MarketStatistic",
        "title": "Thống kê thị trường"
    }

]
export const defaultWatchingList = [
    "VCB",
    "VHM",
    "STB",
    "HPG",
    "MBB",
    "SSI",
    "FPT",
    "CTG",
    "SRA",
    "ABT"
]
class AppStore {
    isSocketConnected: boolean = false
    @observable isReportPage = false;
    @observable companyDetailCode = ""
    // @ts-ignore
    @observable language: string = localStorage.getItem("language") ? localStorage.getItem("language") : "vi-VN"
    // @ts-ignore
    @observable isLightMode: boolean = localStorage.getItem("mode") ? JSON.parse(localStorage.getItem("mode")) : false
    // @observable menuWidth: number = 66
    @observable menuWidth: number = 0
    @observable headerHeight: number = 66
    @observable localDashboardConfig: IDashboardConfig = defaultDashboardConfig
    @observable localWatchingListConfig: string[] = defaultWatchingList
    @observable watchingList?: IStockSymbol[] = undefined
    @observable listShortCompany: IShortCompanyInfo[] = []
    isFirstLoad = false;

    async getListCompanyShortInfo() {
        if (this.listShortCompany.length === 0) {
            const result = await getRequest(Constants.API_DASHBOARD_URL + 'GetListCompanyShortInfo')
            if (result.status < HttpStatusCode.CODE_300) {
                this.listShortCompany = result.body
            }
        }
    }

    async getDefaultDashboardConfig() {
        let localDashboardConfig = localStorage.getItem(Constants.LOCAL_DASH_BOARD_CONFIG_NAME);
        if (localDashboardConfig === null || typeof localDashboardConfig === 'undefined' || localDashboardConfig === '') {
            this.localDashboardConfig = defaultDashboardConfig;
        }
        else {
            this.localDashboardConfig = JSON.parse(localDashboardConfig);
        }
    }

    async getWatchingList() {

        if (!this.watchingList) {
            const localWatchingListConfig = localStorage.getItem(Constants.TVSI_DASHBOARD_WATCHING_LIST)

            if (localWatchingListConfig === null || typeof localWatchingListConfig === 'undefined' || localWatchingListConfig === '') {
                const watchingList: IStockSymbol[] = []
                defaultWatchingList.map((item) => {
                    const symbol: any = {
                        "stockSymbol": item,
                        "percentChange": [

                        ]
                    }
                    watchingList.push(symbol)
                    return item
                })
                this.watchingList = watchingList
            }
            else {
                const watchingList: IStockSymbol[] = []
                JSON.parse(localWatchingListConfig).map((item) => {
                    const symbol: any = {
                        "stockSymbol": item,
                        "percentChange": []
                    }
                    watchingList.push(symbol)
                    return item
                })
                this.watchingList = watchingList
            }
        }
        const listStocks = this.watchingList.map((item) => item.stockSymbol)

        const result = await getRequest(`/api/v1/Trading/StockCharts?ListStockSymbol=${listStocks}`)
        if (result.status < HttpStatusCode.CODE_300) {
            this.watchingList?.map((item, i) => {
                item.percentChange = result.body[i]?.percentChange
                item.value = result.body[i]?.value
                return item
            })
            dashboardStore.checkShowControlButton()
            if (this.isFirstLoad) {
                return;
            }
            this.regisShortStockInfo();
            this.isFirstLoad = true;
        }
    }

    x: any = null;
    regisShortStockInfo(stockSymbols: string[] = []) {
        clearTimeout(this.x)
        this.x = setTimeout(() => {
            if (appStore.isSocketConnected) {
                if (stockSymbols.length === 0) {
                    let listIndexCode = ""
                    topStockStore.stockSymbols?.forEach((item) => {
                        listIndexCode += item + ','
                    })
                    this.watchingList?.forEach((item) => {
                        listIndexCode += item.stockSymbol + ','
                    })
                    if (cashFlowTrendingStore.symbolActive) {
                        listIndexCode += cashFlowTrendingStore.symbolActive + ','
                    }
                    if (stockRankingStore.symbol) {
                        listIndexCode += stockRankingStore.symbol + ',';
                    }
                    if (orderMatchingByPriceStore.currentSymbol) {
                        listIndexCode += orderMatchingByPriceStore.currentSymbol + ','
                    }
                    if (stockDetailStore.symbol) {
                        listIndexCode += stockDetailStore.symbol + ','
                    }

                    stockDetailStore.sameSymbols.forEach((item) => {
                        listIndexCode += item + ','
                    })
                    stockRecommendationStore.stockHolds.forEach((item) => {
                        listIndexCode += item + ','
                    })
                    stockRecommendationStore.stockBuys.forEach((item) => {
                        listIndexCode += item + ','
                    })
                    listIndexCode = listIndexCode.substring(0, listIndexCode.length - 1);
                    realtimeEvent.registerSocket(REGISTER_SOCKET_TYPE.RegisShortStockInfo, listIndexCode)
                } else {
                    realtimeEvent.registerSocket(REGISTER_SOCKET_TYPE.RegisShortStockInfo, stockSymbols.join(','))
                }
            }
        }, 2000)
    }

    updateStockSymbol(data: IStockSymbol[]) {
        if (this.watchingList) {
            this.watchingList.forEach((currentStock, index) => {
                let newStock = data.find((index) => (index.stockSymbol === currentStock.stockSymbol))
                if (newStock && this.watchingList) {
                    let t: IStockSymbol = _.cloneDeep(newStock);
                    t.value = currentStock.value;
                    t.percentChange = currentStock.percentChange;
                    if (currentStock.matchPrice && t.matchPrice && currentStock.matchPrice < t.matchPrice) {
                        t.colorUpdate = STOCK_BG_COLOR_CONIG.UP
                    }
                    if (currentStock.matchPrice && t.matchPrice && currentStock.matchPrice > t.matchPrice) {
                        t.colorUpdate = STOCK_BG_COLOR_CONIG.DOWN
                    }
                    if (currentStock.totalTradingQtty && t.totalTradingQtty && currentStock.totalTradingQtty < t.totalTradingQtty) {
                        t.totalTradingQttyUpdateColor = STOCK_BG_COLOR_CONIG.UP
                    }
                    if (currentStock.totalTradingQtty !== newStock.totalTradingQtty || currentStock.matchPrice !== newStock.matchPrice) {
                        this.watchingList[index] = t
                        this.watchingList[index].isUpdate = true;
                        setTimeout(() => {
                            if (this.watchingList) {
                                this.watchingList[index].colorUpdate = ""
                                this.watchingList[index].totalTradingQttyUpdateColor = ""
                            }

                        }, Constants.EFFECT_UPDATE_TIME)
                    }
                }
            })
        }
    }
}
export const appStore = new AppStore()